var map = {
	"./doc-grey.png": "9802",
	"./doc-light.png": "fb9d",
	"./doc.png": "023f",
	"./heart-light.png": "c32a",
	"./heart.png": "40db",
	"./pay_fail.png": "5807",
	"./pay_success.png": "02a1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e6ac";